export const STORAGE_KEY = "embers-images";

let sessionSchema = {
  version: 1,
  user: null,
  accessToken: null,
  expiresAt: null,
  redirectUrl: null
};

let initialState = {
  session: sessionSchema,
  alert: {
    type: null,
    title: null,
    message: null
  }
};

// Check local storage for our key and retrieve the data, if it exists,
// otherwise use defaults.
if (localStorage.getItem(STORAGE_KEY)) {
  let session = JSON.parse(localStorage.getItem(STORAGE_KEY));
  if (session.version !== sessionSchema.version) session = sessionSchema;
  initialState.session = session;
}

export const state = initialState;
